import type { ReactNode } from "react";

import {
  DeferredCommitStatusGlyph,
  deferredCommitStatusGlyphVisible,
} from "./DeferredCommitStatusGlyph";

export function DeferredCommitFieldFrame({
  label,
  isDirty,
  pending,
  commitError,
  statusGlyphClassName,
  showOverlayGlyph,
  children,
}: {
  label?: ReactNode;
  isDirty: boolean;
  disabled: boolean;
  pending?: boolean;
  commitError?: string | null;
  commitSucceeded?: boolean;
  unsavedHint?: string;
  savedHint?: string;
  statusGlyphClassName?: string;
  showOverlayGlyph: boolean;
  children: ReactNode;
}): JSX.Element {
  const showGlyph = deferredCommitStatusGlyphVisible({
    pending,
    isDirty,
    commitError,
  });
  const glyph = (
    <DeferredCommitStatusGlyph
      pending={pending}
      isDirty={isDirty}
      commitError={commitError}
      className={statusGlyphClassName}
    />
  );

  return (
    <div className="min-w-0">
      {label ? <div className="mb-1.5 flex min-h-5 items-center gap-1">{label}</div> : null}
      <div className="relative min-w-0">
        {children}
        {showGlyph && showOverlayGlyph ? (
          <div className="pointer-events-none absolute right-1 top-1.5 z-10">
            <div className="pointer-events-auto">{glyph}</div>
          </div>
        ) : null}
      </div>
    </div>
  );
}
